import React from 'react';
import { FiInfo } from 'react-icons/fi';

const NoSubscriptionModal = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white mx-4 p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
          <FiInfo className="h-8 w-8 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">No Active Subscription</h2>
        <p className="text-gray-600 mb-6">
          There is no subscription configured for the current term. Please contact Acceede support to set up your subscription.
        </p>
        <a
          href="mailto:support@acceede.com"
          className="inline-block w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-full px-6 py-3 transition-colors"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default NoSubscriptionModal;
